import { useState } from 'react';
import type { Link, Folder } from '../api';

interface Props {
    link: Link;
    folders: Folder[];
    onClose: () => void;
    onMove: (folderId: number | null) => Promise<void>;
}

const MoveToFolderModal = ({ link, folders, onClose, onMove }: Props) => {
    const [selectedFolderId, setSelectedFolderId] = useState<number | null>(link.folderId || null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            await onMove(selectedFolderId);
            onClose();
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card modal-sm" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header no-border">
                    <h2>Déplacer vers...</h2>
                    <button type="button" className="ghost-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body pt-0">
                    <div className="folder-selection-list">
                        <button
                            type="button"
                            className={`folder-option ${selectedFolderId === null ? 'selected' : ''}`}
                            onClick={() => setSelectedFolderId(null)}
                        >
                            <span className="folder-icon">🚫</span>
                            <span className="folder-name">Aucun dossier</span>
                            {selectedFolderId === null && <span className="check-icon">✓</span>}
                        </button>

                        {folders.map((folder) => (
                            <button
                                key={folder.id}
                                type="button"
                                className={`folder-option ${selectedFolderId === folder.id ? 'selected' : ''}`}
                                onClick={() => setSelectedFolderId(folder.id)}
                            >
                                <span className="folder-icon">📁</span>
                                <span className="folder-name">{folder.name}</span>
                                {selectedFolderId === folder.id && <span className="check-icon">✓</span>}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="modal-footer no-border">
                    <button type="button" className="ghost-button" onClick={onClose} disabled={isLoading}>
                        Annuler
                    </button>
                    <button
                        type="button"
                        className="primary"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? '...' : 'Déplacer'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MoveToFolderModal;
